// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// 환경변수를 사용하는 방법 (선택 사항)
// .env 파일에 REACT_APP_FIREBASE_API_KEY 등으로 변수 설정 후 사용
const firebaseConfig = {
apiKey: "AIzaSyCd2QKYTlrdZWnwxpAVI50pMU2pp_22PUI",
authDomain:  "asanmemorial-43e89.firebaseapp.com",
projectId:  "asanmemorial-43e89",
storageBucket:  "asanmemorial-43e89.firebasestorage.app",
messagingSenderId:  "514640627759",
appId:  "1:514640627759:web:ca7260fdf8775300db1eda",
measurementId:  "G-38GRHZFXC7"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics , db };